/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAWPAttachments(awPackageId) {
  const response = await $.soap({
    body: {
      GetAWPAttachments: {
        $xmlns: 'http://dla.mil/ems/bpm/attachment',
        AWPID: awPackageId
      }
    },
    blueprintArrays: [
      'GetAWPAttachmentsResponse.AWPackage',
      'GetAWPAttachmentsResponse.AWPackage.AWPackageAttachments.Attachment',
      'GetAWPAttachmentsResponse.AWPackage.OrderPackage',
      'GetAWPAttachmentsResponse.AWPackage.OrderPackage.Order',
      'GetAWPAttachmentsResponse.AWPackage.OrderPackage.Order.Attachments.Attachment'
    ],
    blueprint: {
      awPackageId: '$..AWPackageID',
      awPackageAttachments: [
        '$..AWPackageAttachments.Attachment',
        {
          id: '$..ID',
          objectTypeId: '$..ObjectTypeID',
          objectId: '$..ObjectID',
          isRequired: '$..IsRequired',
          documentTypeId: '$..DocumentTypeID',
          fileName: '$..FileName',
          uploadedBy: '$..UploadedBy',
          uploadedOn: '$..UploadedOn'
        }
      ],
      orderPackages: [
        '$..OrderPackage',
        {
          orderPackageID: '$..OrderPackageID',
          orders: [
            '$..Order',
            {
              orderID: '$..OrderID',
              attachments: [
                '$..Attachments.Attachment',
                {
                  id: '$..ID',
                  objectTypeId: '$..ObjectTypeID',
                  objectId: '$..ObjectID',
                  isRequired: '$..IsRequired',
                  documentTypeId: '$..DocumentTypeID',
                  fileName: '$..FileName',
                  uploadedBy: '$..UploadedBy',
                  uploadedOn: '$..UploadedOn'
                }
              ]
            }
          ]
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response;
}
